import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CvaLoggerService } from "./services/cva-logger/cva-logger.service";
import { CVANotificationService } from "./services/cva-notification/cva-notification.service";
import { LoginService } from "./services/login/login.service";
import { SpinnerService } from './services/spinner/spinner.service';
import { Subject, takeUntil } from 'rxjs';
import { SessionInactivityService } from './services/session-inactivity/session-inactivity.service';
import { ReAuthPopupService } from './shared/reauth-popup/services/reauth-popup.service';

@Component({
  selector: 'cva-standalone-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  spinnerMessage: string = 'Loading...';

  constructor(
    public cvaLogger: CvaLoggerService,
    public cvaNotificationService: CVANotificationService,
    public router: Router,
    public loginService: LoginService,
    public cdr: ChangeDetectorRef,
    private readonly _elementRef: ElementRef,
    private readonly spinnerService: SpinnerService,
    private readonly sessionInactivityService: SessionInactivityService,
    private readonly reauthPopupService: ReAuthPopupService
  ) { }

  ngOnInit() {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.spinnerService.message$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message: string) => {
        this.spinnerMessage = message;
      });

    this.sessionInactivityService.onInactive(() => this.reauthPopupService.onReAuth());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
